/* EVENTS */
export const GET_EVENTS = "GET_EVENTS";
export const GET_EVENTS_SUCCESS = "GET_EVENTS_SUCCESS";
export const GET_EVENTS_FAIL = "GET_EVENTS_FAIL";

export const GET_EVENTS_LIST = "GET_EVENTS_LIST";
export const GET_EVENTS_LIST_SUCCESS = "GET_EVENTS_LIST_SUCCESS";
export const GET_EVENTS_LIST_FAIL = "GET_EVENTS_LIST_FAIL";

export const GET_PARTICIPANT_LOCATIONS = "GET_PARTICIPANT_LOCATIONS";
export const GET_PARTICIPANT_LOCATIONS_SUCCESS = "GET_PARTICIPANT_LOCATIONS_SUCCESS";
export const GET_PARTICIPANT_LOCATIONS_FAIL = "GET_PARTICIPANT_LOCATIONS_FAIL";

export const ADD_NEW_EVENT = "ADD_NEW_EVENT";
export const ADD_EVENT_SUCCESS = "ADD_EVENT_SUCCESS";
export const ADD_EVENT_FAIL = "ADD_EVENT_FAIL";

export const UPDATE_EVENT = "UPDATE_EVENT";
export const UPDATE_EVENT_SUCCESS = "UPDATE_EVENT_SUCCESS";
export const UPDATE_EVENT_FAIL = "UPDATE_EVENT_FAIL";

export const DELETE_EVENT = "DELETE_EVENT";
export const DELETE_EVENT_SUCCESS = "DELETE_EVENT_SUCCESS";
export const DELETE_EVENT_FAIL = "DELETE_EVENT_FAIL";

export const GET_CATEGORIES = "GET_CATEGORIES";
export const GET_CATEGORIES_SUCCESS = "GET_CATEGORIES_SUCCESS";
export const GET_CATEGORIES_FAIL = "GET_CATEGORIES_FAIL";

export const GET_TASK_BY_ID = "GET_TASK_BY_ID";
export const GET_TASK_BY_ID_SUCCESS = "GET_TASK_BY_ID_SUCCESS";
export const GET_TASK_BY_ID_FAIL = "GET_TASK_BY_ID_FAIL";

export const POST_TASK_DOC = "POST_TASK_DOC";
export const POST_TASK_DOC_SUCCESS = "POST_TASK_DOC_SUCCESS";
export const POST_TASK_DOC_FAIL = "POST_TASK_DOC_FAIL";

export const GET_TASK_DOC = "GET_TASK_DOC";
export const GET_TASK_DOC_SUCCESS = "GET_TASK_DOC_SUCCESS";
export const GET_TASK_DOC_FAIL = "GET_TASK_DOC_FAIL";

export const POST_COMMENT = "POST_COMMENT";
export const POST_COMMENT_SUCCESS = "POST_COMMENT_SUCCESS";
export const POST_COMMENT_FAIL = "POST_COMMENT_FAIL";

export const UPDATE_COMMENT = "UPDATE_COMMENT";
export const UPDATE_COMMENT_SUCCESS = "UPDATE_COMMENT_SUCCESS";
export const UPDATE_COMMENT_FAIL = "UPDATE_COMMENT_FAIL";

export const UPDATE_ADMIN_COMMENT = "UPDATE_ADMIN_COMMENT";
export const UPDATE_ADMIN_COMMENT_SUCCESS = "UPDATE_ADMIN_COMMENT_SUCCESS";
export const UPDATE_ADMIN_COMMENT_FAIL = "UPDATE_ADMIN_COMMENT_FAIL";

export const CHANGE_TASK_STATUS = "CHANGE_TASK_STATUS";
export const CHANGE_TASK_STATUS_SUCCESS = "CHANGE_TASK_STATUS_SUCCESS";
export const CHANGE_TASK_STATUS_FAIL = "CHANGE_TASK_STATUS_FAIL";

export const EXPORT_TASK_DATA = "EXPORT_TASK_DATA";
export const EXPORT_TASK_DATA_SUCCESS = "EXPORT_TASK_DATA_SUCCESS";
export const EXPORT_TASK_DATA_FAIL = "EXPORT_TASK_DATA_FAIL";

export const INSERT_STAFF_TIMMING = "INSERT_STAFF_TIMMING";
export const INSERT_STAFF_TIMMING_SUCCESS = "INSERT_STAFF_TIMMING_SUCCESS";
export const INSERT_STAFF_TIMMING_FAIL = "INSERT_STAFF_TIMMING_FAIL";

export const UPDATE_STAFF_TIMMING = "UPDATE_STAFF_TIMMING";
export const UPDATE_STAFF_TIMMING_SUCCESS = "UPDATE_STAFF_TIMMING_SUCCESS";
export const UPDATE_STAFF_TIMMING_FAIL = "UPDATE_STAFF_TIMMING_FAIL";

export const DELETE_BULK_TASK = "DELETE_BULK_TASK";
export const DELETE_BULK_TASK_SUCCESS = "DELETE_BULK_TASK_SUCCESS";
export const DELETE_BULK_TASK_FAIL = "DELETE_BULK_TASK_FAIL";

export const UPDATE_TASK_DESCRIPTION = "UPDATE_TASK_DESCRIPTION";
export const UPDATE_TASK_DESCRIPTION_SUCCESS = "UPDATE_TASK_DESCRIPTION_SUCCESS";
export const UPDATE_TASK_DESCRIPTION_FAIL = "UPDATE_TASK_DESCRIPTION_FAIL";

export const DELETE_TASK_DESCRIPTION = "DELETE_TASK_DESCRIPTION";
export const DELETE_TASK_DESCRIPTION_SUCCESS = "DELETE_TASK_DESCRIPTION_SUCCESS";
export const DELETE_TASK_DESCRIPTION_FAIL = "DELETE_TASK_DESCRIPTION_FAIL";

export const EDIT_VEHICLE_DETAILS_BY_ADMIN = "EDIT_VEHICLE_DETAILS_BY_ADMIN";
export const EDIT_VEHICLE_DETAILS_BY_ADMIN_SUCCESS = "EDIT_VEHICLE_DETAILS_BY_ADMIN_SUCCESS";
export const EDIT_VEHICLE_DETAILS_BY_ADMIN_FAIL = "EDIT_VEHICLE_DETAILS_BY_ADMIN_FAIL";

export const SET_TASK_PAGE_SEARCH_RANGE = "SET_TASK_PAGE_SEARCH_RANGE";
export const SET_CAL_PAGE_SEARCH_RANGE = "SET_CAL_PAGE_SEARCH_RANGE";

export const CLOCK_IN_RESTRICTION = "CLOCK_IN_RESTRICTION";
export const CLOCK_IN_RESTRICTION_SUCCESS = "CLOCK_IN_RESTRICTION_SUCCESS";
export const CLOCK_IN_RESTRICTION_FAIL = "CLOCK_IN_RESTRICTION_FAIL";

export const DELETE_TASK_DOCS = "DELETE_TASK_DOCS";
export const DELETE_TASK_DOCS_SUCCESS = "DELETE_TASK_DOCS_SUCCESS";
export const DELETE_TASK_DOCS_FAIL = "DELETE_TASK_DOCS_FAIL";

export const TASK_LOGS = "TASK_LOGS";
export const TASK_LOGS_SUCCESS = "TASK_LOGS_SUCCESS";
export const TASK_LOGS_FAIL = "TASK_LOGS_FAIL";

// team
export const TEAM_TASK_DETAIL = "TEAM_TASK_DETAIL";
export const TEAM_TASK_DETAIL_SUCCESS = "TEAM_TASK_DETAIL_SUCCESS";
export const TEAM_TASK_DETAIL_FAIL = "TEAM_TASK_DETAIL_FAIL";

export const TEAM_ENTER_TASK_PROGRESS_NOTE = "TEAM_ENTER_TASK_PROGRESS_NOTE";
export const TEAM_ENTER_TASK_PROGRESS_NOTE_SUCCESS = "TEAM_ENTER_TASK_PROGRESS_NOTE_SUCCESS";
export const TEAM_ENTER_TASK_PROGRESS_NOTE_FAIL = "TEAM_ENTER_TASK_PROGRESS_NOTE_FAIL";

export const TEAM_USER_TYPE = "TEAM_USER_TYPE";

export const RATE_TASK = "RATE_TASK";
export const RATE_TASK_SUCCESS = "RATE_TASK_SUCCESS";
export const RATE_TASK_FAIL = "RATE_TASK_FAIL";

export const SEND_RATE_TASK_EMAIL = "SEND_RATE_TASK_EMAIL";
export const SEND_RATE_TASK_EMAIL_SUCCESS = "SEND_RATE_TASK_EMAIL_SUCCESS";
export const SEND_RATE_TASK_EMAIL_FAIL = "SEND_RATE_TASK_EMAIL_FAIL";
